import { ApolloProvider } from '@apollo/client/react';
import React from 'react';
import { BrowserRouter } from 'react-router';

import { client } from '@/core/apollo/client';

import { AppRoutes } from './routes';

export const App: React.FC = () => (
  <ApolloProvider client={client}>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </ApolloProvider>
);

export default App;
